import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';

export const admin: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('event.title.event-administration') as string;
			},
		},
		path: 'events/:eventId/admin',
		name: Routes.EVENT_ADMIN,
		redirect: { name: Routes.EVENT_ADMIN_DETAILS },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				eventId: route.params.eventId,
			};
		},
		component: () => import(/* webpackChunkName: "event-admin" */ '@front-app/views/home/event/admin/AdminMain.vue'),
		children: [
			{
				meta: {
					title(i18n: VueI18n): string {
						return i18n.t('event.title.edit-event-details') as string;
					},
					trappRoute(to: Route): string {
						return `/dvf.shtml?gd=${to.params.eventId}`;
					},
				},
				path: 'details',
				name: Routes.EVENT_ADMIN_DETAILS,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
						isPostCreateSuccess: route.query.isCreateSuccess === 'true',
					};
				},
				component: () => import(/* webpackChunkName: "event-admin" */ '@front-app/views/home/event/admin/EditDetails.vue'),
			},
			{
				meta: {
					title(i18n: VueI18n): string {
						return i18n.t('event-page.manage-event') as string;
					},
					trappRoute(to: Route): string {
						return `/mv.shtml?gd=${to.params.eventId}`;
					},
				},
				path: 'manage',
				name: Routes.EVENT_ADMIN_MANAGEMENT,
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						groupId: route.params.groupId,
					};
				},
				component: () => import(/* webpackChunkName: "event-admin" */ '@front-app/views/home/event/admin/ManageEvent.vue'),
			},
			// {
			// 	meta: {
			// 		title(i18n: VueI18n): string {
			// 			return i18n.t('event-admin.event-notifications.invitations') as string;
			// 		},
			// 		trappRoute(to: Route): string {
			// 			return `/mv.shtml?gd=${to.params.eventId}`;
			// 		},
			// 	},
			// 	path: 'invitations',
			// 	name: Routes.EVENT_ADMIN_INVITATIONS,
			// 	// eslint-disable-next-line @typescript-eslint/no-explicit-any
			// 	props(route: Route): any {
			// 		return {
			// 			groupId: route.params.groupId,
			// 		};
			// 	},
			// 	component: () => import(/* webpackChunkName: "event-admin" */ '@front-app/views/home/event/admin/EventInvitations.vue'),
			// },
		],
	},
];
